/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  getCustomerEstateListLink,
  getCustomerLeaseListLink,
  getCustomerLink,
  getCustomerMandateListLink,
  getCustomerProspectingListLink,
  getCustomerReportLink
} from '../../lib/links/customerLinks'
import { Button, ButtonVariant, Group } from '@mantine/core'
import { matchPath, NavLink } from 'react-router-dom'
import { useLocation } from 'react-router'
import RequirePerm from '../../../auth/components/RequirePerm'

export type CustomerTabsProps = {
  customerId: number
}

function CustomerTabs (props: CustomerTabsProps) {
  const intl = useIntl()
  const { customerId } = props
  const disabled = !(customerId > 0)
  const location = useLocation()
  const activeVariant: ButtonVariant = 'outline'
  const inactiveVariant: ButtonVariant = 'white'
  return (
    <Group gap="xs">
      <Button
        component={NavLink}
        disabled={disabled}
        to={getCustomerLink(customerId)}
        variant={matchPath(getCustomerLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
      >
        {intl.formatMessage({
          id: 'record',
          defaultMessage: 'Fiche'
        })}
      </Button>
      <RequirePerm
        permissions={['read:estate']}
        render={() => (
          <Button
            component={NavLink}
            disabled={disabled}
            to={getCustomerEstateListLink(customerId)}
            variant={matchPath(getCustomerEstateListLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'estates',
              defaultMessage: 'Biens'
            })}
          </Button>
        )}
      />
      <RequirePerm
        permissions={['read:lease']}
        render={() => (
          <Button
            component={NavLink}
            disabled={disabled}
            to={getCustomerLeaseListLink(customerId)}
            variant={matchPath(getCustomerLeaseListLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'rental_files',
              defaultMessage: 'Dossiers de location'
            })}
          </Button>
        )}
      />
      <RequirePerm
        permissions={['read:mandate']}
        render={() => (
          <Button
            component={NavLink}
            disabled={disabled}
            to={getCustomerMandateListLink(customerId)}
            variant={matchPath(getCustomerMandateListLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'mandates',
              defaultMessage: 'Mandats'
            })}
          </Button>
        )}
      />
      <RequirePerm
        permissions={['read:prospecting']}
        render={() => (
          <Button
            component={NavLink}
            disabled={disabled}
            to={getCustomerProspectingListLink(customerId)}
            variant={matchPath(getCustomerProspectingListLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'prospecting_list',
              defaultMessage: 'Prospections'
            })}
          </Button>
        )}
      />
      <RequirePerm
        permissions={['read:management-report']}
        render={() => (
          <Button
            component={NavLink}
            disabled={disabled}
            to={getCustomerReportLink(customerId)}
            variant={matchPath(getCustomerReportLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'reports',
              defaultMessage: 'Rapports'
            })}
          </Button>
        )}
      />
    </Group>
  )
}

export default CustomerTabs
